import { useQuery } from '@tanstack/react-query';
import { fetchDeliveryOrder, type DeliveryOrder } from '@/data/cargo.api';

export function useDeliveryOrder(orderId?: string, initialOrder?: DeliveryOrder | null) {
  return useQuery({
    queryKey: ['order', orderId],
    queryFn: () => fetchDeliveryOrder(orderId!),
    enabled: Boolean(orderId),
    initialData: initialOrder ?? undefined,
  });
}
